/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-no-comment-textnodes */
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useState } from "react";
import { useParams } from "react-router-dom";
import CustomButton from "./CustomButton";
import '../styles/CheckoutForm.css'
import TermsAndConditions from "./TermsAndConditions";
import { Divider } from "@mui/material";
  
const API_URL = process.env.REACT_APP_API_URL


export default function CheckoutForm({
  paymentIntentId,
  song,
  artist,
  amount,
}) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [acceptedTC, setAcceptedTC] = useState(false);
  const { eventId } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);

    try{
      const bidResponse = await fetch(`${API_URL}/firebase/create-bid`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          eventId: eventId,
          song: song,
          artist: artist,
          amount: amount,
          paymentIntentId: paymentIntentId
        })
      })
      const bidsData = await bidResponse.json()
      const newBidId = bidsData.newBidID
      
      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/Events/${eventId}`,
        },
      })
      if (error) {
        await fetch(`${API_URL}/firebase/reject-bid`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          body: JSON.stringify({
            eventId: eventId,
            bidUID: newBidId
          }),
        })
        if (error.type === "card_error" || error.type === "validation_error") {
          setMessage(error.message);
        } else {
          setMessage("An unexpected error occurred.");
        }
      }
    } catch (e) {
      console.log(e)
    }
    
    setIsProcessing(false);
  };

  const options = {
    layout: {
      type: "accordion",
      defaultCollapsed: false,
      radios: true,
      spacedAccordionItems: false,
    },
  };

  const handleAcceptTC = () => {
    setAcceptedTC(!acceptedTC)
  }

  return (
    // eslint-disable-next-line react/no-unknown-property
    <form id="payment-form" onSubmit={handleSubmit} options={options}>
      <PaymentElement id="payment-element" />
      <Divider sx={{ marginTop: 1 }}/>
      <TermsAndConditions handleAcceptTC={handleAcceptTC}/>
      {acceptedTC ? (
        <div className="checkout-container">
          <button disabled={isProcessing || !stripe || !elements} id="stripe-pay-now-button">
            <span id="button-text">
              {isProcessing ? "Processing ... " : "Pay now"}
            </span>
          </button>
        </div>
      ) : (
        <></>
      )}
    </form>
  );
}
  